export function buildCustomersListTableHeaders({ t }) {
  return [
    {
      value: "id",
      text: t("page.users.id"),
      thClass: "w-24",
      tdClass: "max-w-[2rem] min-w-[5rem]",
      disabled: true,
    },
    {
      value: "name",
      text: t("page.customers.title"),
      thClass: "w-[10rem]",
      tdClass: "max-w-[12rem] min-w-[10rem]",
      disabled: true,
    },
    {
      value: "companies",
      text: t("page.customers.companies"),
      thClass: "w-[5rem]",
      tdClass: "max-w-[10rem] min-w-[10rem]",
    },
    {
      value: "accessGroup",
      text: t("page.customers.accessGroup"),
      thClass: "w-[10rem]",
      tdClass: "max-w-[12rem] min-w-[10rem]",
    },
    {
      value: "dealers",
      text: t("page.customers.users"),
      thClass: "w-[8rem]",
      tdClass: "max-w-[12rem] min-w-[12rem]",
    },
    {
      value: "bonusProgramLevel",
      text: t("page.customers.bonusProgramLevel"),
      thClass: "w-[7rem]",
      tdClass: "max-w-[9rem] min-w-[7rem] capitalize",
    },
    {
      value: "status",
      text: t("page.dealersCompany.status"),
      thClass: "w-[7rem]",
      tdClass: "max-w-[9rem] min-w-[7rem]",
    },
  ];
}
